import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navbar from "../components/Navbar";
import Home from "../pages/Home";
import ForecastAlert from "../pages/Forecast";
import InventoryAlert from "../pages/Inventory";
import PerformanceMatrics from "../pages/PerformanceMatrics"
import ForecastDeepDive from "../pages/ForecastDeepdive";
import ForecastOverview from "../pages/ForecastOverview";
import FeatureImportance from "../pages/FeatureImportance";
import Consensus from "../pages/Consensus";
import ForecastSegmentation from "../pages/ForecastSegmentation";
import InventorySoq from "../pages/InventorySoq";
import Cannibalization from "../pages/Cannibalization";
import PosVsShipped from "../pages/PosVsShipped";
import OnHandVsTarget from "../pages/OnHandVsTarget";
import AdEffectiveness from "../pages/AdEffectiveness";
import AccuracyDeepDive from "../pages/AccuracyDeepDive";
import InventoryOverview from "../pages/InventoryOverview";

const Router = () => {
  return (
    <BrowserRouter>
      <div className="flex flex-col w-full h-full">
        <Navbar></Navbar>
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/forecast/forecast-alerts" element={<ForecastAlert />}></Route>
          <Route path="/inventory/inventory-alerts" element={<InventoryAlert />}></Route>
          <Route path="/PerformanceMetrics" element={<PerformanceMatrics />}></Route>
          <Route path="/ForecastOverview" element={<ForecastOverview />}></Route>
          <Route path="/ForecastDeepDive" element={<ForecastDeepDive />}></Route>
          <Route path="/FeatureImportance" element={<FeatureImportance />}></Route>
          <Route path="/ConsensusPlanning" element={<Consensus />}></Route>
          <Route path="/PosVsShipped" element={<PosVsShipped />}></Route>
          <Route path="/InventoryAndSoq" element={<InventorySoq />}></Route>
          <Route path="/ForecastSegmentation" element={<ForecastSegmentation />}></Route>
          <Route path="/OnHandVsTarget" element={<OnHandVsTarget />}></Route>
          <Route path="/Cannibalization" element={<Cannibalization />}></Route>
          <Route path="/AdEffectiveness" element={<AdEffectiveness />}></Route>
          <Route path="/AccuracyDeepDive" element={<AccuracyDeepDive />}></Route>
          <Route path="/InventoryOverview" element={<InventoryOverview />}></Route>
        </Routes>
      </div>
    </BrowserRouter>
  );
};

export default Router;
